import React, { useRef } from 'react';
import Navigation from './components/Navigation/Navigation';
import Home from './components/Home/Home';
import AboutUs from './components/AboutUs/AboutUs';
import Gallery from './components/Gallery/Gallery';
import Product from './components/Product/Product';
import Contact from './components/Contact/Contact';
import './App.css';

function App() {
  // Create refs for each section
  const homeRef = useRef(null);
  const aboutRef = useRef(null);
  const galleryRef = useRef(null);
  const productRef = useRef(null);
  const contactRef = useRef(null);

  // Scroll to section function
  const scrollToSection = (ref) => {
    ref.current.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div>
      {/* Pass the scroll function to Navigation */}
      <Navigation
        scrollToSection={scrollToSection}
        refs={{ homeRef, aboutRef, galleryRef, productRef, contactRef }}
      />

      <div className="content">
        {/* Ensure Home component has full-screen effect */}
        <section ref={homeRef}><Home /></section>
        <section ref={aboutRef}><AboutUs /></section>
        <section ref={galleryRef}><Gallery /></section>
        <section ref={productRef}><Product /></section>
        <section ref={contactRef}><Contact /></section>
      </div>
    </div>
  );
}

export default App;
